import { Box, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import PageHeader from "../../../../../../../components/PageHeader";
import useClientPlants from "../../../../../../../hooks/useClientPlants";

export default function MRVPage() {
  const { plantId } = useParams();
  const { plants } = useClientPlants();
  const plant = plants.find((p) => String(p.id) === String(plantId)) || { id: plantId };

  return (
    <Box>
      <PageHeader plant={plant} pageTitle="Material Receipt Voucher (MRV)" />
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Coming soon...
        </Typography>
      </Box>
    </Box>
  );
}
